import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names with intelligent conflict resolution.
 * Standard shadcn helper.
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
